module.exports = __webpack_public_path__ + "static/media/services.c7f1d3eb.svg";